import { useState, useEffect } from "react";

interface NavProps {
  scrolled: boolean;
}

function Navbar({ scrolled }: NavProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { href: "#videos", label: "動画紹介" },
    { href: "#creators", label: "キャスト" },
    { href: "#talent", label: "タレント図鑑" },
    { href: "#entry", label: "採用エントリー" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white border-b-4 border-black" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16">
        <a href="#" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/0db9e218ed4dd3e1bbdcabf75b408cd1.png"
            alt="トラックボーイズ"
            className="h-20 w-20 object-contain"
          />
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-6">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`font-black text-sm whitespace-nowrap cursor-pointer hover:text-[#FF0F0F] transition-colors ${
                scrolled ? "text-black" : "text-black"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://www.youtube.com/@truckboys"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#FF0F0F] text-white font-black text-sm px-4 py-2 rounded-full whitespace-nowrap cursor-pointer hover:scale-105 transition-transform border-2 border-black"
          >
            <i className="ri-youtube-fill mr-1"></i> YouTube
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-black text-2xl`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t-4 border-black py-4 px-6 flex flex-col gap-4">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="font-black text-black text-base cursor-pointer"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://www.youtube.com/@truckboys"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#FF0F0F] text-white font-black text-sm px-4 py-2 rounded-full text-center border-2 border-black"
          >
            <i className="ri-youtube-fill mr-1"></i> YouTubeチャンネル
          </a>
        </div>
      )}
    </nav>
  );
}

function Footer() {
  return (
    <footer className="bg-[#F0FFF5] border-t-4 border-black py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/0db9e218ed4dd3e1bbdcabf75b408cd1.png"
              alt="トラックボーイズ"
              className="w-16 h-16 object-contain"
            />
            <div>
              <p className="font-black text-xl text-black">トラックボーイズ</p>
              <p className="text-sm text-gray-500 font-bold">TRUCK BOYS OFFICIAL SITE</p>
            </div>
          </div>

          <div className="flex gap-4 flex-wrap justify-center">
            {[
              { icon: "ri-youtube-fill", label: "YouTube", href: "https://www.youtube.com/@truckboys", color: "#FF0F0F" },
              { icon: "ri-tiktok-fill", label: "TikTok", href: "https://www.tiktok.com/@lifebankdedriver", color: "#010101" },
              { icon: "ri-instagram-fill", label: "Instagram", href: "https://www.instagram.com/lifebank.trackboys/", color: "#E1306C" },
              { icon: "ri-line-fill", label: "LINE", href: "https://line.me/R/ti/p/@697ezvvp", color: "#06C755" },
            ].map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 font-black text-sm px-4 py-2 rounded-full border-4 border-black cursor-pointer hover:scale-105 transition-transform whitespace-nowrap bg-white"
              >
                <i className={`${social.icon} text-lg w-5 h-5 flex items-center justify-center`} style={{ color: social.color }}></i>
                {social.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t-2 border-black/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 font-bold text-sm">
            © 2024 トラックボーイズ All Rights Reserved.
          </p>
          <a
            href="https://lifebank.co.jp/"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer hover:scale-105 transition-transform"
          >
            <img
              src="https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/e2e6ef75-1e45-450a-b7a4-a9f25808e891_Untitled.png?v=0185f2cbfee24bc58a0dfac9e6596929"
              alt="株式会社LifeBank"
              className="h-16 w-auto object-contain"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}

export { Footer, Navbar };
